const getApiBaseUrl = () => {
  // Check if we're running as a widget and have the base URL
  if (window.__DOUG_WIDGET_MODE__ && window.__DOUG_WIDGET_BASE_URL__) {
    return window.__DOUG_WIDGET_BASE_URL__;
  }
  
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:5000';
  }
  
  return window.location.origin;
};

export const saveHistory = async (messages, conversationId) => {
  const API_BASE_URL = getApiBaseUrl();
  try {
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ messages, conversationId }),
      };
      const response = await fetch(`${API_BASE_URL}/save-history`, requestOptions);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
  } catch (error) {
      console.error('Error merging documents:', error);
      throw error;
  }
};

export const sendChatMessage = async (messages, conversationId, onChunk) => {
  const API_BASE_URL = getApiBaseUrl();
  
  try {
    const response = await fetch(`${API_BASE_URL}/chat-completion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages,
        conversation_id: conversationId,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');

    let buffer = '';
    let sourceMap = {};
    let sourceMapReceived = false;
    let done = false;

    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;
    
      if (value) {
        buffer += decoder.decode(value);
        
        // If we haven't received the sourceMap yet, try to extract it
        if (!sourceMapReceived) {
          const jsonMatch = buffer.match(/^({.*?})/s);
          if (jsonMatch) {
            const jsonStr = jsonMatch[1];
            try {
              const jsonData = JSON.parse(jsonStr);
              sourceMap = jsonData;
              sourceMapReceived = true;
              
              // Remove the JSON part from buffer
              buffer = buffer.substring(jsonStr.length);
              
              // Notify about sourceMap
              onChunk('', false, sourceMap);
            } catch (error) {
              // JSON is incomplete, continue buffering
              continue;
            }
          } else {
            // No JSON start found yet, continue buffering
            continue;
          }
        }
        
        // Process remaining buffer for text content and end markers
        if (buffer.includes('"endOfStream": true')) {
          // Extract everything before the endOfStream marker
          const parts = buffer.split('{"endOfStream": true}');
          const contentBeforeEnd = parts[0];
          
          if (contentBeforeEnd) {
            onChunk(contentBeforeEnd, false, sourceMap);
          }
          
          // Signal end of stream
          onChunk('', true, sourceMap);
          
          // Process any remaining content after the end marker (shouldn't happen, but just in case)
          buffer = parts.slice(1).join('{"endOfStream": true}');
        } else if (buffer !== '') {
          // Send the current buffer content
          onChunk(buffer, false, sourceMap);
          buffer = '';
        }
      }
    }
    
    // Handle any remaining buffer content
    if (buffer !== '') {
      onChunk(buffer, false, sourceMap);
    }
    
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};